import { useSelector } from 'react-redux';
import { selectors as settingsSelector } from 'state/settings';

const useIsSpainCountry = () => {
  return useSelector(settingsSelector.getCountry) === 'ES';
};

export default useIsSpainCountry;
